import { NgModule } from "@angular/core";
import { SharedComponentsModule, SharedModule } from "app/shared";
import { ChipsModule } from "primeng-lts/chips";
import { VariableListComponent } from "./variable-list.component";

@NgModule({
    declarations: [VariableListComponent],
    imports: [SharedModule, SharedComponentsModule, ChipsModule],
    exports: [VariableListComponent],
    providers: [],
})
export class VariableListModule {}
